import PropTypes from 'prop-types';
import React from 'react';

import { colors } from 'common/styles/style-constants';

const OpencareLogoPattern = ({ color, height }) => (
  <svg
    viewBox="0 0 1399 1399"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    height={height}
  >
    <path
      d="M997.98 875.542c-49.946.247-78.798 20.212-94.24 36.962-31.822 34.594-31.415 79.722-30.84 90.184v224.42c0 56.977-46.355 103.35-103.34 103.35H624.316c-57.034 0-103.412-46.373-103.412-103.35V1072.02c0-18.913-15.348-34.26-34.264-34.26-18.938 0-34.286 15.347-34.286 34.26v155.087c0 94.78 77.147 171.893 171.963 171.893H769.56c94.792 0 171.914-77.112 171.914-171.893v-225.52l-.12-2.825c-.024-.24-1.1-24.683 12.834-39.837 9.05-9.84 24.11-14.82 44.727-14.82 1.263 0 2.51-.068 3.74-.2h224.478c94.77 0 171.867-77.114 171.867-171.87V626.787c0-94.804-77.098-171.94-171.867-171.94h-145.72c-206.107 0-308.37 112.592-407.257 221.497C581.206 778.69 493.43 875.362 317.66 875.362H171.94c-57.01 0-103.39-46.35-103.39-103.327V626.787c0-57.002 46.38-103.375 103.39-103.375h225.595c48.702 0 77.434-19.51 92.95-35.887 34.86-36.772 33.28-86.4 33.018-90.112V171.87c0-56.98 46.378-103.328 103.412-103.328h145.242c56.986 0 103.34 46.35 103.34 103.327v154.823c0 18.937 15.372 34.283 34.288 34.283 18.94 0 34.287-15.346 34.287-34.283V171.87C944.072 77.09 866.95 0 772.157 0H626.915c-94.817 0-171.963 77.09-171.963 171.87l.072 227.386c0 .24.383 25.64-14.294 41.13-9.243 9.72-23.37 14.46-43.195 14.46H171.94C77.12 454.846 0 531.983 0 626.786v145.25c0 94.755 77.122 171.868 171.94 171.868h145.72c206.106 0 308.37-112.592 407.256-221.474 92.95-102.37 180.726-199.018 356.496-199.018h145.72c56.963 0 103.294 46.373 103.294 103.375v145.248c0 56.978-46.33 103.327-103.293 103.327h-225.62c-1.193 0-2.372.06-3.534.18z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
OpencareLogoPattern.defaultProps = {
  color: colors.sage7,
  height: '15px',
};

OpencareLogoPattern.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
};

export default OpencareLogoPattern;
